<template>
   <div id="app" class="app-container">
     <el-drawer
       :withHeader="false"
       :visible.sync="isOpen"
       direction="ttb"
       size="100%"
       :show-close="false">
       <div class="main">
         <div class="left-side">
           <div class="logo">
             <i class="logout el-icon-d-arrow-left" @click="logout"></i>
             <div class="title">收银台</div>
             <div class="store" v-if="storeInfo">{{ storeInfo.name }}</div>
             <!-- <div class="account">您好，{{ accountInfo.realName }}！</div> -->
           </div>
           <div class="cate">
             <ul class="nav">
               <li class="nav-item" v-for="menu in menuList">
                 <a :class="'nav-link' + (activeMenu == menu.key ? ' active' : '')" href="javascript:;" @click="switchMenu(menu.key)">
                    <!-- <img class="cate-logo" :src="menu.logo"> -->
                    <span>{{ menu.name }}</span>
                 </a>
               </li>
             </ul>
           </div>
         </div>
         <div class="cart-container" v-if="activeMenu == 'cashier'">
           <div class="title">
             <div class="logo">
               <!-- <img class="avatar" v-if="!memberInfo || !memberInfo.avatar" src="@/assets/images/avatar.png" />
               <img class="avatar" v-else :src="memberInfo.avatar"/> -->
             </div>
             <div class="member-info">
               <span class="name" v-if="memberInfo.user_id>0">{{ memberInfo.mobile ? memberInfo.mobile : memberInfo.name }}</span>
               <span class="none" v-if="memberInfo.user_id<=0">当前为游客</span>
               <el-button size="mini" class="switch" type="danger" icon="el-icon" @click="switchMember()">关联会员</el-button>
               <el-button size="mini" class="switch"  icon="el-icon" @click="flush()">刷新</el-button>
               <el-button size="mini" class="switch"  icon="el-icon" @click="flusha()">切换游客</el-button>
           
              </div>
           </div>
           <div class="carts">
             <div>
               <div class="tab">
                 <div class="cart-list" v-if="cartList.length > 0">
                   <div class="cart-item" v-for="cartInfo in cartList">
                     <img class="image" :src="cartInfo.product_info.product_image"/>
                     <div class="info">
                       <div class="name">{{ cartInfo.product_info.product_name }}</div>
                       <div class="spec" >
                         <span class="item" >{{ cartInfo.product_info.product_sku.product_attr }}</span>
                       </div>
                       <div class="num"><el-input-number class="input" @change="changeBuyNum(cartInfo)" 
                        v-model="cartInfo.num" :min="1" :max="1000"/></div>
                     </div>
                     <div class="option">
                       <div class="remove el-icon-delete" @click="removeFromCart(cartInfo.cart_id)"></div>
                       <div class="total" >￥{{ (cartInfo.product_price * cartInfo.num).toFixed(2) }}</div>
                       <div class="total" 
                       v-if="cartInfo.product_price  != cartInfo.original_price"
                       style="margin-top: -5px;font-size: 14px; color: #999; text-decoration: line-through;"
                       >￥{{ (cartInfo.original_price * cartInfo.num).toFixed(2) }}</div>
                    
                      </div>
                   </div>
                 </div>
                 <div class="empty" v-if="cartList.length < 1">
                     <el-empty description="暂无结算商品" :image-size="40"></el-empty>
                 </div>
               </div>
             </div>
           </div>
           <div class="footer">
             <div class="number">
               <div class="total-num">总件数：<b class="num">{{ cartTotalNum }}</b></div>
               <div class="total-price">总金额：<b class="num">￥{{ cartTotalPrice ? cartTotalPrice.toFixed(2) : '0.00' }}</b></div>
             </div>
             <div class="options">
               <div class="cash" @click="hangUp()">挂单 / 取单</div>
               <div class="submit" v-if="cartTotalNum > 0" @click="doSettlement()">提交结算</div>
               <div class="submit" v-if="cartTotalNum == 0" @click="doCashier()">无商品收款</div>
             </div>
           </div>
         </div>
         <div class="main-list" v-if="activeMenu == 'cashier'">
            <div class="title">
              <el-form class="search-form" ref="searchForm" :inline="true" :model="searchForm">
                <el-form-item class="form-item" label="" prop="search">
                  <el-input v-model="searchForm.search" prefix-icon="el-icon-full-screen" @keyup.enter.native="doQueryGoods" class="input-item" placeholder="请输入商品关键字：商品名称、条码、商品ID..." clearable maxlength="100" />
                </el-form-item>
                <el-button class="search-goods" @click="doQueryGoods()" icon="el-icon-search">查询商品</el-button>
              </el-form>
              <!-- 分类 -->
              <el-tabs class="tab-box" type="card" v-model="navTab" @tab-click="switchTab">
                <el-tab-pane label="全部" name="0"></el-tab-pane>
                <el-tab-pane v-for="tab in tabList" :label="tab.name" :key="tab.category_id+''" :name="tab.category_id+''"></el-tab-pane>
              </el-tabs>
            </div>
            <!-- 商品 -->
            <div class="goods-list">
              <div class="goods-item" v-for="goodsInfo in goodsList">
                  <div class="item" @click="clickGoods(goodsInfo.product_id)">
                    <img class="image" lazy :src="goodsInfo.product_image">
                    <div class="goods-name">{{ goodsInfo.product_name }}</div>
                    <div class="goods-price">￥{{ goodsInfo.product_price }}</div>
                  </div>
              </div>
              <div class="pagination">
                  <el-pagination  style="margin-top: 10px;padding-left: 15px;padding-right: 15px;"   v-if="totalDataNumber > 0" @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  background :current-page="curPage"
                  :page-size="pageSize" layout="total, prev, pager, next, jumper"
                  :total="totalDataNumber"
        
                  >
                </el-pagination>
              </div>
     
          
              <el-empty v-if="goodsList.length == 0" description="暂无商品..."></el-empty>
            </div>
         </div>

         <!-- 订单列表组件 start-->
         <!-- <orderList v-if="activeMenu == 'order'" @doPayOrder="doPayOrder"></orderList> -->
         <!-- 订单列表组件 end-->

         <!-- 会员列表组件 start-->
         <!-- <memberList v-if="activeMenu == 'member'"></memberList> -->
         <!-- 会员列表组件 end-->

         <!-- 卡券核销组件 start-->
         <!-- <couponConfirm v-if="activeMenu == 'coupon'"></couponConfirm> -->
         <!-- 卡券核销组件 end-->
       </div>
     </el-drawer>

     <!-- 规格详情 start-->
     <el-dialog title="选择商品规格" :visible.sync="openGoodsDialog" class="common-dialog" append-to-body>
       <div class="goods-info">
        <div class="product-popup">
          <div class="body">
            <div>
              <img style="width: 100px;height: 100px;border-radius: 10px;" 
              :src="show_sku.sku_image"></img>
            </div>
		
          <div class="name">{{ show_sku.product_name }}</div>
         <div class="price" >￥{{ show_sku.product_price }}
        
        </div>
        
          <div class="stock" >
            库存：{{show_sku.stock_num}}
          </div>   

					<!--规格-->
					<div v-if="specData !=null">
						<div class="specs mt20" v-if="item_attr.spec_items.length > 0"
							v-for="(item_attr,attr_index) in specData.spec_attr" :key="attr_index">
							<div class="specs-hd" style="padding-top: 10px;">
								<text class="f24" style="color: black;">{{item_attr.group_name}}</text>
								<text class="ml10 red" v-if="productSpecArr[attr_index]==null">
									请选择{{item_attr.group_name}}
								</text>
							</div>
							<div class="specs-list">
								<button type="primary" :class="item.checked ? 'btn-red' : 'btn-gray-border'"
									v-for="(item,item_index) in item_attr.spec_items" :key="item_index"
									@click="selectAttr(attr_index, item_index)">{{item.spec_value}}
								</button>
							</div>
						</div>
					</div>

          					<!--选择数量--> 
					<div class="level-box count_choose" style="margin-top: 20px;"> 
						<text class="key">数量</text>
						<div class="d-s-c">
              <div class="num"><el-input-number class="input" v-model="goodsNum" :min="1" :max="1000"/></div>
						</div>
					</div>

			</div>
        </div>
    
       </div>
       <div slot="footer" class="dialog-footer">
         <el-button type="primary" class="main-button" @click="addToCart('',goodsNum,0)">加入结算</el-button>
         <el-button @click="closeGoodsDialog()">取 消</el-button>
       </div>
     </el-dialog>
     <!-- 规格详情 end-->

     <!--关联会员对话框 start-->
     <switchMemberDialog :show-dialog="openSwitchMemberDialog" @doSwitchMember="doSwitchMember"/>
     <!--关联会员对话框 end-->

     <!--结算对话框 start-->
     <settlementDialog :show-dialog="openSettlementDialog" :memberInfo="memberInfo" :totalPrice="cartTotalPrice" :remarks="cartRemark" :orderInfo="orderInfo" :couponList="couponList" @submit="submitSettlement" @switchMember="switchMember" @closeDialog="closeDialog"/>
     <!--结算对话框 end-->

     <!--扫码付款对话框 start-->
     <!-- <scanPayCodeDialog ref="scanPayCodeDialog" :show-dialog="openScanPayCodeDialog" :memberInfo="memberInfo" :orderId="orderId" :payType="payType" :payAmount="payAmount" @closeDialog="closeDialog" @showPayResult="showPayResult"/> -->
     <!--扫码付款对话框 end-->

     <!--支付结果对话框 start-->
     <!-- <payResultDialog :show-dialog="openPayResultDialog" :payResult="payResult" @showOrderPrint="showOrderPrint" @closeDialog="closeDialog"/> -->
     <!--支付结果对话框 end-->

     <!--打印订单对话框 start-->
     <!-- <orderPrintDialog :show-dialog="openOrderPrintDialog" :storeInfo="storeInfo" :orderInfo="orderInfo" @closeDialog="closeDialog"/> -->
     <!--打印订单对话框 end-->

     <!--挂单对话框 start-->
     <hangUpDialog  :show-dialog="openHangUpDialog" :memberInfo="memberInfo" :cartList="cartList" 
     @getHangNo="getHangNo" @doHangUp="doHangUp" @closeDialog="closeDialog"/>
     <!--挂单对话框 end-->

     <!-- 无商品收款组件 start-->
     <!-- <noGoodsCashier :show-dialog="openNoGoodsCashierDialog" @submit="submitCashier" @closeDialog="closeDialog"></noGoodsCashier> -->
     <!-- 无商品收款组件 end-->
   </div>
</template>

<script>
//import { init, getGoodsInfo, searchGoods, getCartList, saveCart, removeFromCart, submitSettlement, doPay, getMemberInfoById } from "@/api/cashier";
// import { getOrderInfo } from "@/api/order";
// import { getUserId, setUserId, removeUserId } from '@/utils/auth';
import switchMemberDialog from "./components/switchMemberDialog";
import settlementDialog from "./components/settlementDialog";
// import scanPayCodeDialog from "./components/scanPayCodeDialog";
// import payResultDialog from "./components/payResultDialog";
// import orderPrintDialog from "./components/orderPrintDialog";
import hangUpDialog from "./components/hangUpDialog";
// import orderList from "./components/orderList";
// import memberList from "./components/memberList";
// import couponConfirm from "./components/couponConfirm";
// import noGoodsCashier from "./components/noGoodsCashier";

import CashdeskApi from '@/api/cashdesk.js';
export default {
  name: "Cashier",
  components: {
    switchMemberDialog,
    settlementDialog,
    // scanPayCodeDialog,
    // payResultDialog,
    // orderPrintDialog,
    hangUpDialog,
    // orderList,
    // memberList,
    // couponConfirm,
    // noGoodsCashier
  },
  data() {
    return {
      // 系统名称
      systemName: process.env.VUE_APP_TITLE,
      // 导航tab
      navTab: '0',
      isOpen: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      openGoodsDialog: false,
      openSwitchMemberDialog: false,
      openSettlementDialog: false,
      openNoGoodsCashierDialog: false,
      openScanPayCodeDialog: false,
      openPayResultDialog: false,
      openOrderPrintDialog: false,
      openHangUpDialog: false,
      searchForm: { search: '',category_id:0, },
      payResult: { isSuccess: false, payAmount: 0, orderId: 0 },
      goodsForm: {},
      // 左侧菜单
      menuList: [{ name: '收银主页', key: 'cashier', logo:  "" },
                //  { name: '订单管理', key: 'order', logo: ""},
                //  { name: '会员管理', key: 'member', logo: ""},
                //  { name: '卡券核销', key: 'coupon', logo:""}
                ],
      // 激活菜单
      //require('../../assets/images/cashier.png') 
      //require('../../assets/images/order.png') 
      // require('../../assets/images/hot.png')
      // require('../../assets/images/life.png') 
      activeMenu: 'cashier',
      // 导航栏tab
      tabList: [],

      // 当前登录用户
      accountInfo: {},
      // 当前门店信息
      storeInfo: {},
      // 当前操作商品
      goodsInfo: { num : 1, specList : [], skuList: [] },
      // 当前选择属性
      goodsSpecIds: [],
      // 商品数量
      goodsNum: 1,
      // 图片目录
      imagePath: '',
      // 商品分类列表
      cateList: [],
      // 商品列表
      goodsList: [],
      // 购物车列表
      cartList: [],
      // 订单列表
      orderList: [],
      // 总金额
      cartTotalPrice: 0,
      // 购物车备注
      cartRemark: '',
      // 总件数
      cartTotalNum: 0,
      // 支付金额
      payAmount: 0,
      // 当前订单号
      orderId: 0,
      // 支付方式
      payType: '',
      // 当前订单
      orderInfo: {},
      // 可用卡券列表
      couponList: [],
      // 挂单序号
      hangNo: '',
      isSearch: false,


      specData:[],//商品规格
      productSpecArr:[],//规格组
      show_sku:{},

      // 当前操作会员
      memberInfo: {
        user_id:0,
      },


      barcode_num:"",//条形码

      curPage:1,
      pageSize:10,
    };
  },
  mounted() {
    // const app = this;
    // // 监听扫码枪按键
    // let code = '';
    // let lastTime, nextTime; // 上次时间、最新时间
    // let lastCode, nextCode; // 上次按键、最新按键
    // document.onkeypress = (e) => {
    //   // 获取按键
    //   if (window.event) { // IE
    //       nextCode = e.keyCode;
    //   } else if (e.which) { // Netscape/Firefox/Opera
    //       nextCode = e.which;
    //   }
    //   // 如果触发了回车事件(扫码结束时间)
    //   if (nextCode === 13) {
    //       if (code.length < 3) {
    //           return;
    //       }
    //       if (app.openScanPayCodeDialog == true) {
    //           app.$refs.scanPayCodeDialog.submit(code);
    //           return false;
    //       }
    //       if (app.openSwitchMemberDialog == true) {
    //           return false;
    //       }
    //       if (app.openSettlementDialog == true) {
    //           app.$alert("请点击确定收款！");
    //           return false;
    //       }
    //       app.addToCart(code);
    //       code = '';
    //       lastCode = '';
    //       lastTime = '';
    //       return true;
    //   }
    //   nextTime = new Date().getTime(); // 记录最新时间
    //   if (!lastTime && !lastCode) { // 如果上次时间和上次按键为空
    //       code += e.key; // 执行叠加操作
    //   }
    //   // 如果有上次时间及上次按键
    //   if (lastCode && lastTime && nextTime - lastTime > 30) {
    //       code = e.key;
    //   } else if (lastCode && lastTime) {
    //       code += e.key;
    //   }
    //   lastCode = nextCode;
    //   lastTime = nextTime;
    // }
  },
  created() {
    this.initCashier();
    this.getStore();
    // this.getCartList();
    //获取一级分类
    this.getCategory();
  },
  methods: {
    // 初始化数据
    initCashier() {
      const app = this;

      //获取商品
      this.getProduct();
      this.getCartList();

      // init(user_id, app.cateId, app.page, app.pageSize).then( response => {
      //     app.cateList = response.data.cateList;
      //     app.tabList = response.data.cateList;
      //     app.goodsList = response.data.goodsList;
      //     app.imagePath = response.data.imagePath;
      //     app.storeInfo = response.data.storeInfo;
      //     app.accountInfo = response.data.accountInfo;
      //     app.memberInfo = response.data.memberInfo;
      //     app.totalGoods = response.data.totalGoods;
      //     app.loading = false;
      //     app.hangNo = '';
      //   }
      // ).catch((err) => {
      //    // empty
      // });
    },
      /*选择第几页*/
      handleCurrentChange(val) {
      this.curPage = val;
      this.getProduct();
    },
    /*每页多少条*/
        handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    getProduct(type=0){
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      CashdeskApi.getProduct(Params, true)
        .then(data => {
          self.loading = false;
          console.log(' data.data.list.data', data.data.list.data)
          if ( data.data.list.data &&   data.data.list.data.length > 0) {
            self.goodsList = data.data.list.data;
            self.totalDataNumber =  data.data.list.total;
          } else {
            console.log("type",type)
            if(type == 1){
              self.$alert("抱歉，未查询到商品信息！");
              return false;
            }
      
          }
        })
        .catch(error => {});
    },
    getCategory(){
      let self = this;
      let Params = {};
      CashdeskApi.getCategory(Params, true)
        .then(data => {
          self.loading = false;
          self.tabList = data.data.list;
       
        })
        .catch(error => {});
    },
    // 菜单切换
    switchMenu(menuKey) {
      this.activeMenu = menuKey;
      return menuKey;
    },
    // tab切换
    switchTab(el) {
      this.navTab = el.name;
      this.filterCate(this.navTab);
    },
    // 过滤分类商品
    filterCate(cateId) {
      this.goodsList = [];
       this.searchForm.category_id = cateId;
       this.initCashier();
    },
    // 购物车列表
    getCartList() {
      const self = this;
      if (self.loading) {
          return false;
      }
      self.loading = true;
      self.cartList = [];
        CashdeskApi.getCartList({}, true)
          .then(data => {
            self.loading = false;
            console.log("购物车",data);
            self.cartList = data.data.val;
            self.cartTotalPrice = data.data.cartTotalPrice;
            self.cartTotalNum = data.data.cartTotalNum;
            self.memberInfo = data.data.memberInfo;
          })
          .catch(error => {});

      // const switchCartIds = cartIds ? cartIds.join(",") : "";
      // getCartList({ user_id: getUserId(), hangNo: app.hangNo, cartIds: switchCartIds }).then( response => {
      //      const cartList = response.data.list;
      //      if (cartList && cartList.length > 0) {
      //          cartList.forEach(function(item) {
      //             const specList = [];
      //             if (item.specList && item.specList.length > 0) {
      //                 item.specList.forEach(function (spec) {
      //                   specList.push({name: spec.specName, value: spec.specValue});
      //                 })
      //             }
      //             const cartInfo = { cartId: item.id, skuId: item.skuId, goodsId: item.goodsInfo.id, name: item.goodsInfo.name, logo: item.goodsInfo.logo, price: item.goodsInfo.price, buyNum: item.num, specList: specList };
      //             app.cartList.push(cartInfo);
      //          })
      //      }
      //      app.cartTotalPrice = response.data.payPrice;
      //      app.cartTotalNum = response.data.totalNum;
      //      app.couponList = response.data.couponList;
      //      app.loading = false;
      // }).catch((err) => {
      //     // empty
      // });
    },
    // 查询商品
    doQueryGoods() {
      const self = this;

      self.loading = true;
      self.goodsList = [];
      self.getProduct(1);
    },
    // 点击商品规格弹框
    clickGoods(product_id) {
      const app = this;
      if (app.loading) {
          return false;
      }
      app.loading = true;
      let self = this;
      let Params = {
        product_id:product_id
      };
      CashdeskApi.getProductDetail(Params, true)
        .then(data => {
          self.loading = false;
 
          self.goodsInfo = data.data.list.detail;
          self.goodsNum = 1;
    
          self.specData = data.data.list.specData 

          self.initSpecData(self.specData);
        
          self.productSpecArr =self.specData != null ? new Array(self.specData.spec_attr.length) : [];
 
           self.updateSpecProduct();
           self.initShowSku();
           self.openGoodsDialog = true;
        
        
        })
        .catch(error => {});
    },
        	/*初始化*/
			initShowSku() {
        var self = this;
				let img_cover = '';
				if (this.goodsInfo.image.length > 0) {
					img_cover = self.goodsInfo.image ? self.goodsInfo.image[0].file_path : ''
				} else {
					if (self.goodsInfo.default_image.length > 0) {
						if (self.goodsInfo.default_image[0].file_path) {
							img_cover = self.goodsInfo.default_image[0].file_path
						}
					}
				}
        this.show_sku.product_name = self.goodsInfo.product_name;
				this.show_sku.sku_image = img_cover;
				this.show_sku.product_price = self.goodsInfo.product_price;
				this.show_sku.product_sku_id = 0;
				this.show_sku.line_price = self.goodsInfo.line_price;
				this.show_sku.stock_num = self.goodsInfo.product_stock;
        this.show_sku.product_id = self.goodsInfo.product_id;
				this.show_sku.sum = 1;
				this.stock = self.goodsInfo.product_stock;
			},
			/*多规格商品*/
			initSpecData(data) {
				for (let i in data.spec_attr) {
					var spec = [];
					if (data.spec_attr[i] &&
						data.spec_attr[i].spec_items &&
						data.spec_attr[i].spec_items.length > 0) {
						for (let j in data.spec_attr[i].spec_items) {
							data.spec_attr[i].spec_items[j].checked = false;
							spec.push(data.spec_attr[i].spec_items[j])
						}
						data.spec_attr[i].spec_items = spec;
					}
				}
				this.specData = data;
			},
    	/*更新商品规格信息*/
			updateSpecProduct() {
				let self = this;
				let specSkuId = self.productSpecArr.join('_');
				// // 查找skuItem
				let spec_list = self.specData.spec_list,
					skuItem = spec_list.find((val) => {
						return val.spec_sku_id == specSkuId;
					});
				// 记录product_sku_id
				// 更新商品价格、划线价、库存
				if (typeof skuItem === 'object') {
					self.stock = skuItem.spec_form.stock_num;
					if (self.goodsNum> self.stock) {
						self.goodsNum = self.stock > 0 ? self.stock : 1;
					}

          self.show_sku.product_sku_id = specSkuId;
					self.show_sku.product_price = skuItem.spec_form.product_price;
					self.show_sku.line_price = skuItem.spec_form.line_price;
					self.show_sku.stock_num = skuItem.spec_form.stock_num;
          self.show_sku.product_id = self.goodsInfo.product_id;
					if (skuItem.spec_form.image_id > 0) {
						self.show_sku.sku_image = skuItem.spec_form.image_path;
					} else {
						self.show_sku.sku_image = self.goodsInfo.image.length > 0 ? self.goodsInfo.image[0]
							.file_path : '';
					}
	
				}
  
			},
      /*选择属性*/
			selectAttr(attr_index, item_index) {
				let self = this;
				let items = self.specData.spec_attr[attr_index].spec_items;
				let curItem = items[item_index];

				if (curItem) {

					if (curItem.checked) {
						curItem.checked = false;
						self.productSpecArr[attr_index] = null;
					} else {
						if (items && items.length > 0) {
							for (let i = 0; i < items.length; i++) {
								items[i].checked = false;
							}
							curItem.checked = true;

							self.productSpecArr[attr_index] = curItem.item_id;
						}

					}
          items[item_index] = curItem;
 
          self.$forceUpdate()
					for (let i = 0; i < self.productSpecArr.length; i++) {
						console.log(self.productSpecArr[i])
						if (self.productSpecArr[i] == null) {
							self.initShowSku();
							return;
						}
					}
					// 更新商品规格信息
					self.updateSpecProduct();
				}
			},

    // 关闭规格弹框
    closeGoodsDialog() {
       this.openGoodsDialog = false;
    },
    // 选择商品属性
    selectGoodsSpec(specId) {
       const app = this;
       let specIds = [];
       app.goodsInfo.specList.forEach(function() {
          specIds.push(0);
       })
       app.goodsInfo.specList.forEach(function(specItem, index) {
          const children = [];
          specItem.child.forEach(function(child) {
              children.push(child.id)
          })
          if (children.includes(specId)) {
              specIds[index] = specId
          } else {
              specIds[index] = app.goodsSpecIds[index] == undefined ? 0 : app.goodsSpecIds[index];
          }
       })
       app.goodsSpecIds = specIds;
    },
    // 加入购物车
    //num  添加的数量
    //type 0  累计添加  1  覆盖添加
    addToCart(skuNo="",num=1,type=0) {
      let self = this;
      self.isSearch = false;
      // 扫码枪扫描商品条码，直接加入购物车
      if (skuNo) {
          self.addCart(skuNo);
          return;
      }
      console.log('self.show_sku.product_id',self.show_sku.product_id);
      console.log('num',num);
      if (self.loading || !self.show_sku.product_id || num <= 0) {
          return false;
      }
   
      if (this.specData != null) {
					for (let i = 0; i < this.productSpecArr.length; i++) {
						if (this.productSpecArr[i] == null) {
              self.$alert("请选择规格");
							return;
						}
					}
				}
        
        let product_sku_id = self.show_sku.product_sku_id;
        let product_id = self.show_sku.product_id;
        let user_id = self.memberInfo.user_id;
        CashdeskApi.addCart({
          product_id:product_id,
          product_sku_id:product_sku_id,
          num: num,
          user_id:user_id,
          type:type
        }, true)
        .then(data => {
          self.loading = false;
          if(data.code == 1){
            self.openGoodsDialog = false;
            self.getCartList();
            if(type == 0){
              self.$message({
                message: "添加成功",
                type: 'success'
              })
            }
          
      
          }
        })
        .catch(error => {});  
    },
    addCart(barcode_num){//如果传了条形码 就要查询这个商品存不存在 如果存在 则插入购物车
      var self = this;
      CashdeskApi.addCartByBarcodenum({
          barcode_num:barcode_num,
          user_id:self.memberInfo.user_id
        }, true)
        .then(data => {
          self.loading = false;
          if(data.code == 1){
            self.getCartList();
            self.openGoodsDialog = false;
            self.$message({
              message: "添加成功",
              type: 'success'
            })
         
      
          }else{
            self.$alert(data.msg);
          }
        })
        .catch(error => {});  
    },

    // 删除购物车
    removeFromCart(cart_id) {
      const self = this;
      self.loading = true;

        self
          .$confirm('是否移除改商品?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
           
              CashdeskApi.delCart({
                cart_id:cart_id
                }, true)
                .then(data => {
                  self.loading = false;
                  if(data.code == 1){
                    self.getCartList();
                  }
                })
                .catch(error => {});  
                  })
          .catch(() => {
          });  


    },
    flush(){
      this.getCartList();
    },
    flusha(){
      const self = this;
      self.loading = true;
      self.$confirm('是否切换游客?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
          
              CashdeskApi.canelRelatedUser({}, true)
                .then(data => {
                  self.loading = false;
                  if(data.code == 1){
                    self.getCartList();
                    self.memberInfo = {
                      user_id:0
                    }
                  }
                })
                .catch(error => {});  
                  })
          .catch(() => {
        });  

    
    },
    // 购物车数量变化
    changeBuyNum(cartInfo) {
      const self = this;
      self.show_sku.product_sku_id = cartInfo.product_info. product_sku.spec_sku_id;
      self.show_sku.product_id = cartInfo.product_info.product_sku.product_id;
			self.show_sku.product_price = cartInfo.product_price;
			self.show_sku.line_price = cartInfo.product_info.product_sku.line_price;
			self.show_sku.stock_num = cartInfo.product_info.product_sku.stock_num;
      self.show_sku.sku_image = cartInfo.product_image;
      self.addToCart('',cartInfo.num,1);
    },
    // 弹出关联会员
    switchMember() {
       this.openSwitchMemberDialog = true;
    },
    // 确认关联会员
    doSwitchMember(memberInfo) {
      var self  =this;
      this.openSwitchMemberDialog = false;
      if (memberInfo != 0) {
          this.memberInfo = memberInfo;
          if (memberInfo) {
              let cartIds = [];
              if (this.cartList && this.cartList.length > 0) {
                this.cartList.forEach(function(cart){
                  cartIds.push(cart.cartId);
                })
              }

              CashdeskApi.relatedUser({
                user_id:memberInfo.user_id
              }, true)
                .then(data => {
                  self.getCartList();
                })
                .catch(error => {});
          
          } else {
              // removeUserId();
              this.getCartList();
          }
      }
    },
    logout() {
      this.$router.push( '/' );
    },
    // 发起结算
    doSettlement() {
       if (this.cartList.length < 1) {
           this.$alert("请先添加结算商品！");
           return false;
       }
      //  this.getCartList();
       this.orderInfo = {};
       this.openSettlementDialog = true;
    },
    // 无商品结算
    doCashier() {
      this.orderInfo = {};
      this.openNoGoodsCashierDialog = true;
    },
    submitCashier(param) {
      this.orderInfo = {};
      this.openSettlementDialog = true;
      this.cartTotalPrice = parseFloat(param.amount);
      this.cartRemark = param.remark;
      this.openNoGoodsCashierDialog = false;
    },
    // 确认结算
    submitSettlement(param) {
      const app = this;
      // 已生成的订单支付
      if (app.orderInfo.id) {
          // 微信、支付宝支付
          if (param.payType == 'MICROPAY' || param.payType == 'ALISCAN') {
              app.payAmount = app.orderInfo.payAmount;
              app.orderId = app.orderInfo.id;
              app.openScanPayCodeDialog = true;
              app.openSettlementDialog = false;
              app.payType = param.payType;
          }
          // 现金、余额支付
          if (param.payType == 'CASH' || param.payType == '10') {
  
            // doPay({ orderId: app.orderId, payType: param.payType, cashierPayAmount: param.totalPrice, cashierDiscountAmount: param.discountPrice, user_id: getUserId() }).then( response => {
              //     app.openSettlementDialog = false;
              //     if (response.data.orderInfo.payStatus == 'B') {
              //         app.showPayResult({ isSuccess: true, payAmount: response.data.orderInfo.payAmount, orderId: response.data.orderInfo.id });
              //     } else {
              //         app.$alert(response.data.message ? response.data.message : "抱歉，订单操作异常！");
              //     }
              // })
          }
          return false;
      }
      // 购物车提交结算
      let cartIds = [];
      app.cartList.forEach(function(cart){
          cartIds.push(cart.cart_id);
      })
      const parmas = { cashierPayAmount: param.totalPrice,
                     cashierDiscountAmount: param.discountPrice,
                     cartIds: cartIds.join(','),
                     orderMode: 'oneself',
                     payType: param.payType,
                     remark: param.remark,
                     type: app.cartList.length > 0 ? 'goods' : 'payment',
                     coupon_id: param.userCouponId ? param.userCouponId : 0,
                     user_id: app.memberInfo.user_id };
      // if (app.loading) {
      //     return false;
      // }
      // app.loading = true;
      console.log('parmas',parmas);

      CashdeskApi.buy(parmas, true)
                .then(data => {
                  if(data.code == 1){
                    //创建订单成功 弹出确认支付界面
                  }else{
                    self.$message({
                      message: data.msg,
                      type: 'error'
                    })
             
                  }
                })
                .catch(error => {});

    
      return;
      submitSettlement(data).then( response => {
          app.loading = false;
          app.doSwitchMember(null);
          app.initCashier();
          app.getCartList();
          // 微信支付，弹出扫码框
          if (response.data.orderInfo.payType == 'MICROPAY' || param.payType == 'ALISCAN') {
              app.payAmount = response.data.orderInfo.payAmount;
              app.orderId = response.data.orderInfo.id;
              app.openScanPayCodeDialog = true;
              app.openSettlementDialog = false;
              app.payType = param.payType;
              return false;
          }
          // 现金、余额支付
          if (response.data.orderInfo.payType == 'CASH' || response.data.orderInfo.payType == 'BALANCE') {
              app.openSettlementDialog = false;
              if (response.data.orderInfo.payStatus == 'B') {
                  app.showPayResult({ isSuccess: true, payAmount: response.data.orderInfo.payAmount, orderId: response.data.orderInfo.id });
              } else {
                  app.$alert(response.data.message);
              }
              return false;
          }
          if (response.code == '201') {
              app.$alert(response.data.message);
          }
          return false;
      }).catch(() => {
          app.loading = false;
      });
    },
    // 点击挂单/取单
    hangUp() {
       this.openHangUpDialog = true;
    },
    // 取单
    getHangNo(data) {
       this.openHangUpDialog = false;
       this.hangNo = data.hangNo;
       this.getCartList();
       // 关联会员信息
       if (data.hangNo && data.hangNo.length > 0 ) {
           this.doSwitchMember(data.memberInfo);
       }
    },
    // 执行挂单
    doHangUp() {
      this.hangNo = '';
      this.getCartList();
      // removeUserId();
      this.memberInfo = {user_id:0};
    },
    // 关闭对话框
    closeDialog(dialog) {
      console.log("dialog",dialog);
      this.getCartList();
       if (dialog == 'settlementDialog') {
           this.openSettlementDialog = false;
       } else if (dialog == 'switchMemberDialog') {
           this.openSwitchMemberDialog = false;
       } else if (dialog == 'scanPayCodeDialog') {
           this.openScanPayCodeDialog = false;
       } else if (dialog == 'payResultDialog') {
           this.openPayResultDialog = false;
       } else if (dialog == 'printOrder') {
           this.openOrderPrintDialog = false;
       } else if (dialog == 'hangUpDialog') {
           this.openHangUpDialog = false;
       } else if (dialog == 'openNoGoodsCashierDialog') {
           this.openNoGoodsCashierDialog = false;
       }
    },
    // 展示支付结果
    showPayResult(payResult) {
       this.payResult = payResult;
       this.openPayResultDialog = true;
    },
    // 订单支付
    doPayOrder(orderInfo) {
       const app = this;
       app.payAmount = orderInfo.amount;
       app.orderId = orderInfo.id;
       app.orderInfo = orderInfo;
       let user_id = 0
       if (orderInfo.isVisitor !== "Y") {
           user_id = app.orderInfo.userInfo.id;
       }
       getMemberInfoById(user_id).then(response => {
          if (response.data.memberInfo) {
              app.memberInfo = response.data.memberInfo;
          } else {
              app.memberInfo = null;
          }
       }).catch(() => {
           // empty
       });
       app.doSwitchMember(app.memberInfo);
       app.openSettlementDialog = true;
    },
    // 打印小票
    showOrderPrint(orderId) {
      const app = this;
      // getOrderInfo(orderId).then(response => {
      //   if (response.data.orderInfo) {
      //       app.orderInfo = response.data.orderInfo;
      //       app.openOrderPrintDialog = true;
      //   }
      // }).catch(() => {
      //     // empty
      // });
    },
    getStore(){
      var self = this;
      var type = 0;
      CashdeskApi.getStore({
          type:type,

        }, true)
        .then(data => {
          self.loading = false;
          if(type == type){
            self.storeInfo = data.data
          }else{
            self.storeInfo = data.data
          }
        })
        .catch(error => {});  
    }
  }
};
</script>

<style lang="scss" scoped>
   .main {
     height: 100%;
     width: 100%;
     display: flex;
     flex-direction: row;
     .pagination {
       position: fixed;
       bottom: 10px;
       height: 50px;
       line-height: 50px;
       right: 10px;
       margin-top: 10px;
       display: block;
       background: #ffffff;
       box-shadow: 0 4px 8px 0 rgba(167, 167, 167, 0.6);
       color: #ffffff;
       border-radius: 5px;
       z-index: 99999;
     }
     .left-side {
        width: 160px;
        height: 100%;
        background: #409EFF;
        border-right: #888888 solid 2px;
        position: absolute;
        left: 0;
        top: 0px;
        padding: 0px;
        color: #FFFFFF;
        overflow-x: hidden;
        overflow-y: auto;
        display: block;
        text-align: center;
       .logo {
         height: 90px;
         padding: 20px 12px 10px 12px;
         font-weight: bold;
         .logout {
           float: left;
           height: 20px;
           line-height: 20px;
           text-align: left;
           width: 100%;
           cursor: pointer;
         }
         .store {
           font-size: 12px;
         }
         .account {
           font-size: 12px;
           border: solid 2px #FFFFFF;
           background: #6c757d;
           cursor: pointer;
           margin-top: 6px;
           padding: 2px;
           border-radius: 2px;
         }
       }
       .cate {
         text-align: center;
         margin-left: 14px;
         margin-top: 10px;
         .nav {
            list-style: none;
            display: block;
            margin: 0px;
            padding: 5px;
            text-align: center;
            .nav-item {
                margin-top: 20px;
                font-size: 14px;
                width: 120px;
                text-align: center;
               .nav-link {
                 position: relative;
                 padding: .5356875rem .9375rem;
                 white-space: nowrap;
                 text-align: center;
                 font-weight: 600;
                 color: #666666;
                 display: flex;
                 align-items: center;
                 flex-direction: column;
                 justify-content: center;
                 border-radius: 5px;
                 transition: color .2s linear;
                 background: #f5f5f5;
                 border: 2px solid #FFFFFF;
                 .cate-logo {
                   display: block;
                   width: 50px;
                   height: 50px;
                 }
               }
               .active {
                 font-weight: bold;
                 border: 4px #ff5b57 solid;
               }
            }
         }
       }
     }
     .cart-container {
        width: 310px;
        height: 100%;
        background: #FFFFFF;
        display: block;
        position: absolute;
        left: 165px;
        top: 0px;
        overflow-x: hidden;
        overflow-y: auto;
        border: #cccccc solid 1px;
        .title {
          height: 70px;
          width: 310px;
          background: #6c757d;
          border-bottom: #CCCCCC 2px solid;
          color: #FFFFFF;
          padding-top: 16px;
          padding-left: 1px;
          display: block;
          position: fixed;
          top: 0px;
          z-index: 999;
          clear: both;
          .logo {
            float: left;
            font-size: 24px;
            .avatar {
               width: 15px;
               height: 15px;
               border-radius: 40px;
               margin: 5px 0px 5px 5px;
            }
          }
          .member-info {
            float: left;
            margin-top: 5px;
            .name {
              margin-left: 2px;
              margin-right: 3px;
            }
            .none {
               margin-left: 2px;
               margin-right: 5px;
               font-size: 13px;
            }
            .switch {
              padding: 8px 8px 8px 4px;
            }
          }
        }
       .carts {
          display: block;
          width: 100%;
          color: #666666;
          margin-bottom: 120px;
          margin-top: 70px;
          padding: 0px;
          .tab {
            width: 50%;
            .cart-list {
               margin-bottom: 60px;
              .cart-item {
                border-bottom: dashed 1px #cccccc;
                height: 110px;
                width: 310px;
                padding-top: 5px;
                .image {
                   width: 50px;
                   height: 50px;
                   margin-left: 5px;
                   border-radius: 5px;
                   border: solid 1px #ccc;
                   float: left;
                   margin-top: 20px;
                }
                .info {
                   float: left;
                   padding-left: 5px;
                   margin-top: 5px;
                   .name {
                     font-weight: bold;
                     font-size: 12px;
                     width: 160px;
                     max-height: 15px;
                     overflow: hidden;
                     display: -webkit-box;
                     -webkit-box-orient: vertical;
                     -webkit-line-clamp: 2;
                   }
                   .spec {
                     font-size: 12px;
                     width: 160px;
                     height: 20px;
                     margin-top: 2px;
                     .item {
                        margin-right: 2px;
                        border-radius: 5px;
                        text-align: center;
                        max-width: 250px;
                        height: 20px;
                        line-height: 20px;
                        float: left;
                        display: block;
                        overflow: hidden;
                        color: #606266;
                        cursor: pointer;
                        background: #cceeee;
                        padding: 0px 3px 0px 3px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                     }
                   }
                   .input {
                     width: 120px;
                     margin-top: 2px;
                   }
                }
                .option {
                   float: right;
                   text-align: right;
                   margin-right: 10px;
                   .remove {
                      font-size: 12px;
                      cursor: pointer;
                   }
                   .total {
                     margin-top: 10px;
                     font-size: 16px;
                     color: #ff5b57;
                   }
                }
              }
            }
            .empty {
              margin-top: 200px;
              width: 310px;
            }
          }
       }
       .footer {
          position: fixed;
          z-index: 999;
          background: #6c757d;
          bottom: 0;
          height: 120px;
          width: 100%;
          padding-top: 5px;
          padding-right: 15px;
          color: #FFFFFF;
          display: block;
          width: 310px;
          border: solid 3px #cccccc;
          .number {
            float: right;
            margin: 5px;
            font-size: 13px;
            .total-price {
               margin-top: 3px;
               .num {
                 color: #ff5b57;
                 font-size: 20px;
               }
            }
          }
          .options {
             text-align: center;
             cursor: pointer;
             float: right;
             color: #FFFFFF;
            .cash {
              float: left;
              height: 50px;
              border: solid 1px #409EFF;
              padding-top: 15px;
              width: 135px;
              border-radius: 5px;
              background: #409EFF;
              font-weight: bold;
            }
            .submit {
               float: left;
               height: 50px;
               border: solid 1px #ff5b57;
               margin-left: 10px;
               padding-top: 15px;
               width: 135px;
               border-radius: 5px;
               background: #ff5b57;
               font-weight: bold;
            }
          }
       }
     }
     .main-list {
       height: 100%;
       width: 100%;
       min-width: 760px;
       margin-left: 475px;
       margin-right: 2px;
       overflow: auto;
       display: block;
       background: #FFFFFF;
       margin-bottom: 10px;
       .title {
         position: fixed;
         height: 106px;
         width: calc(100% - 465px);
         min-width: 700px;
         background: #ffffff;
         padding: 5px;
         color: red;
         top: 0px;
         .search-form {
            height: 50px;
            .form-item {
              margin-right: -2px;
            }
            .input-item {
              min-width: 456px;
            }
            .search-goods {
              height: 50px;
              background: #409EFF;
              margin-left: 3px;
              color: #fff;
            }
         }
         .tab-box {
            margin-top: 3px;
            width: 100%;
         }
       }
       .goods-list {
         height: 100%;
         width: 100%;
         margin-top: 103px;
         margin-left: 2px;
         margin-bottom: 20px;
         .goods-item {
           width: 33.3%;
           min-height: 300px;
           min-width: 220px;
           padding: 3px;
           float: left;
           background: #ffffff;
           text-align: left;
           cursor: pointer;
           .item {
              background: #ffffff;
              padding: 5px;
              border-radius: 5px;
              border: solid 1px #cccccc;
              margin: 0px;
             .goods-name {
               margin-top: 10px;
               font-size: 18px;
               color: #666666;
               height: 30px;
               overflow: hidden;
               white-space: nowrap;
               text-overflow: ellipsis;
             }
             .goods-price {
               color: #ff5b57;
               font-size: 18px;
               font-weight: bold;
             }
             .image {
               width: 100%;
               height: 220px;
               border-radius: 3px;
             }
           }
         }
       }
     }
   }
   .goods-info {
     border: solid 1px #ccc;
     padding: 15px;
     border-radius: 5px;
     .name {
       
        font-weight: bold;
        font-size: 20px; 
        color: #606266;
     }
     .price {
       height: 40px;
       color: #ff5b57;
       font-size: 20px;
     
     }
     .spec-list {
        border: solid 1px #ccc;
        padding: 20px;
        margin-top: 10px;
        border-radius: 6px;
        .spec-item {
           margin-bottom: 20px;
          .spec-name {
             font-weight: bold;
             font-size: 16px;
          }
          .values {
             display: block;
             padding-top: 10px;
             margin-left: 0px;
             padding-left: 0px;
             font-size: 12px;
             .value {
               border: solid 1px #cceeee;
               margin-right: 10px;
               padding: 8px 15px 5px 15px;
               cursor: pointer;
               border-radius: 4px;
               background: rgba(0, 172, 172, 0.1);
               color: #666666;
             }
             .active {
               border: solid 1px #ff5891;
               background: #ff5b57;
               color: #FFFFFF;
             }
          }
        }
     }
   }
</style>
<style scoped>
  .input-item >>> .el-input__inner {
    border: #409EFF solid 2px;
    line-height: 50px;
    height: 50px;
  }
  .form-item >>> .el-form-item__label {
    line-height: 50px;
    height: 50px;
  }
  .el-tabs--border-card {
    box-shadow: none;
    border: none;
  }
  ::v-deep .el-tabs--border-card > .el-tabs__content {
    padding: 0px;
  }
  ::v-deep .el-pagination.is-background span {
    color: #fff;
  }

  .product-popup .header {
		height: 120px;
		padding: 10px 0 10px 250px;
		position: relative;
		border-bottom: 1px solid #EEEEEE;
	}

	.product-popup .header .avt {
		position: absolute;
		top: -80px;
		left: 15px;
		width: 200px;
		height: 200px;
		border: 2px solid #FFFFFF;
		background: #FFFFFF;
	}



	.product-popup .close-btn {
		position: absolute;
		width: 40px;
		height: 40px;
		top: 10px;
		right: 10px;
	}



	.product-popup .price .num {
		padding: 0 4px;
		font-size: 25px;
	}

	.product-popup .old-price {
		margin-left: 10px;
		font-size: 15px;
		color: #999999;
		text-decoration: line-through;
	}

	.product-popup .body {
		padding: 0px 0px;
		height: 400px;
		overflow-y: auto;
		.body-scroll {
			height: 100%;
		}
	}

	.product-popup .level-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.product-popup .level-box .key {
		font-size: 24px;
		color: #999999;
	}

	.product-popup .level-box .icon-box {
		width: 60px;
		height: 60px;
		border: 1px solid #DDDDDD;
		background: #f7f7f7;
	}

	.product-popup .num-wrap .iconfont {
		color: #666;
	}

	.product-popup .num-wrap.no-stock .iconfont {
		color: #CCCCCC;
	}

	.product-popup .level-box .text-wrap {
		margin: 0 4px;
		height: 30px;
		border: 1px solid #DDDDDD;
		background: #f7f7f7;
	}

	.product-popup .level-box .text-wrap input {
		padding: 0 10px;
		height:30px;
		line-height: 30px;
		width: 80px;
		text-align: center;
	}

	.specs .specs-list {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}

	.specs .specs-list button {
		margin-right: 10px;
		font-size: 12px;
	}

	.specs .specs-list button:after,
	.product-popup .btns button,
	.product-popup .btns button:after {

		border: 0;
		border-radius: 0;
	}

.btn-red{
  background: #f05454;
  padding: 10px;
  text-align: center;
  line-height: 15px;
  margin-right: 10px;
  border: 1px solid #f5f5f5;
  border-radius: 5px;
  color: #fff;
}
.btn-gray-border{
  background: #f5f5f5; 
  padding: 10px;
  text-align: center;
  line-height: 15px;
  margin-right: 10px;
  border: 1px solid #f5f5f5;  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/cashdesk/cashier/index.vue